var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("textarea", {
    ref: "textarea",
    staticClass:
      "w-full h-32 rounded-lg p-4 text-sm overflow-y-auto resize-none",
    class: [`color-${_vm.color}`],
    attrs: { disabled: _vm.disabled, placeholder: _vm.placeholder },
    domProps: { value: _vm.value },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event.target.value)
      },
      focusout: _vm.onEvent,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }